export function createDefaultAccountingTable() {
    return {
        columns: ['Concepto', 'Importe (€)'],
        rows: [
            ['Importe total', ''],
            ['Contratos', ''],
            ['Asistencia técnica', ''],
            ['Exceso de medición', ''],
            ['Total', ''],
            ['Sobrante provisional', ''],
        ],
        cellStyles: {},
        columnWidths: [280, 160],
    };
}
